module.exports = __webpack_public_path__ + "img/pic-3.3c0f4032.png";